import React, { useState, useEffect } from 'react';
import {
  TextField,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Modal,
  Box
} from '@mui/material';
import { API, graphqlOperation } from 'aws-amplify';
import { createCalendarItemType, updateCalendarItemType, deleteCalendarItemType } from '../graphql/mutations'; // Assuming deleteCalendarItemType mutation exists
import { listCalendarItemTypes } from '../graphql/queries';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  tableContainer: {
    boxShadow: '0px 8px 16px 0px rgba(0,0,0,0.1)',
    borderRadius: '12px',
    overflow: 'hidden',
    marginBottom: '15px',
    backgroundColor: '#f9f9f9',
  },
  tableHeader: {
    backgroundColor: '#01b5e2',
    color: 'white',
    fontWeight: 'bold',
    fontSize: '1rem',
  },
  tableRow: {
    '&:hover': {
      backgroundColor: '#e5f7fb',
    },
  },
  tableCell: {
    padding: theme.spacing(1.5, 2),
    fontSize: '0.9rem',
  },
  modal: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    backgroundColor: 'white',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
}));


const AddCalendarTypeForm = () => {
  const classes = useStyles();

  const [name, setName] = useState('');
  const [color, setColor] = useState('');
  const [calendarTypes, setCalendarTypes] = useState([]);
  const [editingCalendarTypeId, setEditingCalendarTypeId] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [deleteCalendarTypeId, setDeleteCalendarTypeId] = useState(null);

  useEffect(() => {

    fetchCalendarTypes();
  }, []);

  const fetchCalendarTypes = async () => {
    const response = await API.graphql(graphqlOperation(listCalendarItemTypes));
    setCalendarTypes(response.data.listCalendarItemTypes.items);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (editingCalendarTypeId) {
      // Update existing guidance type
      await API.graphql(
        graphqlOperation(updateCalendarItemType, {
          input: {
            id: editingCalendarTypeId,
            name: name,
            colour: color,
          },
        })
      );
    } else {
      // Create new guidance type
      await API.graphql(
        graphqlOperation(createCalendarItemType, {
          input: {
            name: name,
            colour: color,
            deleted: 'False',
          },
        })
      );
    }

    // Clear form fields
    setName('');
    setColor('');
    setEditingCalendarTypeId(null);

    fetchCalendarTypes();
  };

  const handleEdit = (calendarTypeId) => {
    const calendarType = calendarTypes.find((type) => type.id === calendarTypeId);
    if (calendarType) {
      setName(calendarType.name);
      setColor(calendarType.colour);
      setEditingCalendarTypeId(calendarTypeId);
    }
  };

  const handleCancelEdit = () => {
    setName('');
    setColor('');
    setEditingCalendarTypeId(null);
  };

  const handleColorChange = (event) => {
    setColor(event.target.value);
  };

  const handleDelete = async () => {
    await API.graphql(
      graphqlOperation(deleteCalendarItemType, {
        input: { id: deleteCalendarTypeId }
      })
    );
    setShowModal(false);
    fetchCalendarTypes();
  };

  const openModal = (calendarTypeId) => {
    setDeleteCalendarTypeId(calendarTypeId);
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
  };


  return (
    <div>
      <form onSubmit={handleSubmit}>
        <TextField
          label="Name"
          variant="outlined"
          value={name}
          onChange={(event) => setName(event.target.value)}
          fullWidth
          margin="normal"
        />
        <input
          type="color"
          value={color}
          onChange={handleColorChange}
          style={{ width: '100%', height: '56px', marginTop: '16px' }}
        />
        <br />
        <br />
        <Button type="submit" variant="contained" color="primary">
          {editingCalendarTypeId ? 'Update' : 'Submit'}
        </Button>
        {editingCalendarTypeId && (
          <Button variant="outlined" color="secondary" onClick={handleCancelEdit} style={{ marginLeft: '16px' }}>
            Cancel
          </Button>
        )}
      </form>


      <TableContainer component={Paper} className={classes.tableContainer} style={{ marginTop: '32px' }}>
        <Table>
          <TableHead>
            <TableRow className={classes.tableHeader}>
              <TableCell>Name</TableCell>
              <TableCell>Color</TableCell>
              <TableCell>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {calendarTypes.map((calendarType) => (
              <TableRow key={calendarType.id} className={classes.tableRow}>
                <TableCell className={classes.tableCell}>{calendarType.name}</TableCell>
                <TableCell className={classes.tableCell}>
                  <div
                    style={{
                      width: '24px',
                      height: '24px',
                      backgroundColor: calendarType.colour,
                      borderRadius: '50%',
                    }}
                  ></div>
                </TableCell>
                <TableCell className={classes.tableCell}>
                  <Button variant="outlined" color="primary" onClick={() => handleEdit(calendarType.id)}>
                    Edit
                  </Button>
                  <Button variant="outlined" color="secondary" onClick={() => openModal(calendarType.id)} style={{ marginLeft: '16px' }}>
                    Delete
                  </Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <Modal
        open={showModal}
        onClose={closeModal}
      >
        <Box className={classes.modal}>
          <h2>Are you sure you want to delete this calendar type?</h2>
          <Button variant="contained" color="primary" onClick={handleDelete}>Yes</Button>
          <Button variant="outlined" color="secondary" onClick={closeModal} style={{ marginLeft: '16px' }}>No</Button>
        </Box>
      </Modal>

    </div>
  );
};

export default AddCalendarTypeForm;
